import React, {
  Fragment, useContext, useEffect, useState,
} from 'react';
import useFetch from '../../../../services/useFetch';
import TextField from '../../../../components/TextField';
import BackButton from '../../../../components/BackButton';
import Button from '../../../../components/Button';
import DatePicker from '../../../../components/DatePicker';
import TimePicker from '../../../../components/TimePicker';
import Form from '../../../../components/Form';
import Title from '../../../../components/Title';
import Select from '../../../../components/Select';
import Switch from '../../../../components/Switch';
import validate from './validation';
import { DispatchDialogContext } from '../../../../providers/DialogProvider/DialogContext';
import { formatSelect } from '../../../../utils/yup-utils';

const propTypes = {};

const fetchConfig = {
  initalMethod: 'post',
  initialUri: '/api/v1/communication_campaign/upsert',
  showSuccessMessage: false,
  showErrorMessage: false,
};

const initialForm = {
  title: null,
  body: null,
  type: null,
  all_group: 0,
  file: null,
  scheduled: false,
  delivery_date: null,
  delivery_hour: null,
  company: null,
  provider: null,
  discount: null,
};

const initialType = {
  type: [
    { value: 1, label: 'Por DNI' },
    { value: 2, label: 'Por Empresa' },
    { value: 3, label: 'Descuentos' },
  ],
};

function NewPush() {
  const dialog = useContext(DispatchDialogContext);
  const fetch = useFetch(fetchConfig);
  const [typesSend, setTypesSend] = useState(initialType);
  const [companies, setCompanies] = useState({});
  const [providers, setProviders] = useState({});
  const [discounts, setDiscounts] = useState({});
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const title = 'Push Notification';
  const fileRefs = {
    form: React.useRef(null),
    file: React.useRef(null),
  };

  async function getCompanies() {
    const config = {
      method: 'get',
      uri: '/service/v1/notification/company',
    };
    const keys = {
      id_company: 'value',
      name: 'label',
    };
    const { data } = await fetch.fetch({}, config);
    setCompanies({ ...companies, company: formatSelect(keys, data) });
  }

  async function getProvider(company) {
    const config = {
      method: 'get',
      uri: `/service/v1/notification/providers/${company}`,
    };
    const keys = {
      id_provider: 'value',
      description: 'label',
    };
    const { data } = await fetch.fetch({}, config);
    setProviders({ ...providers, provider: formatSelect(keys, data) });
  }

  async function getDiscount(company, provider) {
    const config = {
      method: 'get',
      uri: `/service/v1/notification/discounts/${company}?id_provider=${provider}`,
    };
    const keys = {
      id_discount: 'value',
      description: 'label',
    };
    const { data } = await fetch.fetch({}, config);
    setDiscounts({ ...discounts, discount: formatSelect(keys, data) });
  }

  useEffect(() => {
    getCompanies();
  }, []);

  function handleInputChange(event) {
    const { target } = event;
    const { name, value } = target;

    switch (name) {
      case 'type':
        setForm({
          ...form,
          [name]: value,
          company: null,
          provider: null,
          discount: null,
          all_group: 0,
        });
        break;
      case 'all_group':
        setForm({
          ...form,
          [name]: value,
          company: null,
        });
        break;
      case 'scheduled':
        setForm({
          ...form,
          [name]: value,
          delivery_date: null,
          delivery_hour: null,
        });
        break;
      case 'company':
        setForm({
          ...form,
          [name]: value,
          provider: null,
          discount: null,
        });
        getProvider(value);
        break;
      case 'provider':
        setForm({
          ...form,
          [name]: value,
          discount: null,
        });
        getDiscount(form.company, value);
        break;
      default:
        setForm({ ...form, [name]: value });
        break;
    }
  }

  function handleDateChange(name) {
    return value => setForm({ ...form, [name]: value });
  }

  function handleFileChange(ref) {
    return () => {
      if (fileRefs[ref].current.files[0]) {
        setForm({ ...form, [ref]: fileRefs[ref].current.files[0] });
      } else {
        setForm({ ...form, [ref]: null });
      }
    };
  }

  function handleReset() {
    setForm(initialForm);
    fileRefs.form.current.reset();
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setErrors({});
    console.log(form);
    const result = await validate(form);
    console.log(result.errors);
    setErrors(result.errors);

    if (!result.isValid) {
      dialog({
        type: 'error',
        content: 'El formulario presenta errores.',
      });
      return;
    }

    const config = {
      method: 'post',
      uri: '/service/v1/notification/send',
      contentType: 'multipart/form-data',
    };
    const data = {
      title: form.title,
      content: form.body,
      type: form.type,
      file_push: form.file,
      all_group: form.all_group,
      id_company: form.company,
      id_discount: form.discount,
      scheduled: form.scheduled,
      scheduled_datetime: form.scheduled
        ? `${form.delivery_date.format('YYYY-MM-DD')} ${form.delivery_hour.format('HH:mm:ss')}`
        : '',
    };
    const response = await fetch.fetch(data, config);
    if (response.success) {
      handleReset();
    }
    dialog({
      type: response.success ? 'success' : 'error',
      content: response.message,
    });
  }

  return (
    <Fragment>
      <BackButton />
      <Form
        ref={fileRefs.form}
        xs={12}
        onSubmit={handleSubmit}
      >
        <Title variant="h5" component="h2">{title}</Title>

        <TextField
          type="text"
          name="title"
          label="Título"
          value={form.title || ''}
          onChange={handleInputChange}
          error={!!errors.title}
          helperText={errors.title}
        />

        <TextField
          type="textarea"
          name="body"
          label="Contenido"
          value={form.body || ''}
          onChange={handleInputChange}
          multiline
          rows={4}
          error={!!errors.body}
          helperText={errors.body}
        />

        <Select
          name="type"
          label="Tipo"
          value={form.type || ''}
          onChange={handleInputChange}
          options={typesSend.type}
          // labelKey="text"
          // valueKey="id"
          error={!!errors.type}
          helperText={errors.type}
        />

        {form.type === 2 && (
          <Switch
            name="all_group"
            label="Enviar a todos las empresas"
            value={form.all_group || ''}
            onChange={handleInputChange}
            checkedValue={1}
            uncheckedValue={0}
          />
        )}

        {form.type >= 2 && form.all_group === 0 && (
          <Select
            name="company"
            label="Empresa"
            value={form.company || ''}
            onChange={handleInputChange}
            options={companies.company}
            error={!!errors.company}
            helperText={errors.company}
          />
        )}

        {form.company && form.type === 3 && (
          <Select
            name="provider"
            label="Comercio"
            value={form.provider || ''}
            onChange={handleInputChange}
            options={providers.provider}
            // labelKey="text"
            // valueKey="value"
            error={!!errors.provider}
            helperText={errors.provider}
          />
        )}

        {form.provider && form.type === 3 && (
          <Select
            name="discount"
            label="Beneficio"
            value={form.discount || ''}
            onChange={handleInputChange}
            options={discounts.discount}
            // labelKey="text"
            // valueKey="value"
            error={!!errors.discount}
            helperText={errors.discount}
          />
        )}

        {form.type === 1 && (
          <TextField
            type="file"
            name="file"
            label="Excel de usuarios"
            onChange={handleFileChange('file')}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              ref: fileRefs.file,
              accept: '.xlsx',
            }}
            error={!!errors.file}
            helperText={errors.file || (
              <>
                <a
                  href="https://solera-qa.s3.amazonaws.com/grupo-romero/files/push_notification.xlsx"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Descargar
                </a>
                &nbsp;plantilla de usuarios
              </>
            )}
          />
        )}

        <Switch
          name="scheduled"
          label="Push programado"
          value={form.scheduled || ''}
          onChange={handleInputChange}
          // checkedValue={1}
          // uncheckedValue={0}
        />

        {form.scheduled && (
          <>
            <DatePicker
              label="Fecha de envío"
              value={form.delivery_date}
              onChange={handleDateChange('delivery_date')}
              error={!!errors.delivery_date}
              helperText={errors.delivery_date}
            />

            <TimePicker
              label="Hora de envío"
              value={form.delivery_hour}
              onChange={handleDateChange('delivery_hour')}
              error={!!errors.delivery_hour}
              helperText={errors.delivery_hour}
            />
          </>
        )}

        <Button type="submit" color="primary" disabled={fetch.isLoading} square>Guardar</Button>
      </Form>
    </Fragment>
  );
}

NewPush.propTypes = propTypes;

export default NewPush;
